import React from 'react'

const AppActionContext = React.createContext<React.RefObject<HTMLDivElement> | null>(null)

export default AppActionContext
